import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

export class IntercomGroupItem {
  id: string;
  text: string;
  value : string;
}

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class IntercomGroup {
  constructor(private http: HttpClient) {}

  getIntercomGroupList(): Observable<any> {
    const get_url = baseApiUrl + 'commonList/intercomGroup';
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res as IntercomGroupItem[]),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
}
